module.exports = "/_next/static/images/sa1-line-fd591f9a09cc9815268ec2e50aca4786.svg";